import React from 'react';

import SideMenuLink from '@/shared/components/molecules/SideMenu/SideMenuLink';
import SideMenuNestedRoutes from '@/shared/components/molecules/SideMenu/SideMenuNestedRoutes';
import { ISideMenu } from '@/shared/components/molecules/SideMenu/types';

const SideMenuItem: React.FC<ISideMenu.ISideMenuItemProps> = ({
  openCollapse,
  item,
}) => {
  return item.nestedMenu?.length ? (
    <SideMenuNestedRoutes item={item} openCollapse={openCollapse} />
  ) : (
    <SideMenuLink item={item} openCollapse={openCollapse} />
  );
  // <Tooltip
  //   background={themeColors().background['neutral-99']}
  //   className='react-tooltip-rounded'
  //   direction={isAr ? 'left' : 'right'}d
  //   useHover={!openCollapse}
  //   content={
  //     <div className='flex flex-col gap-16 whitespace-nowrap'>
  //       <Typography
  //         variant='body2'
  //         className={clsx(
  //           item?.nestedMenu && 'border-b-xs border-background-disable pb-8'
  //         )}
  //       >
  //         {item?.title}
  //       </Typography>

  //       {item?.nestedMenu
  //         ?.filter((nested) => nested?.revealRoute !== false)
  //         .map((nested, index) =>
  //           nested.clickable ? (
  //             <Link
  //               prefetch={false}
  //               href={nested.route}
  //               legacyBehavior
  //               key={index}
  //             >
  //               <a className=''>
  //                 <Typography variant='body2'>{nested.title}</Typography>
  //               </a>
  //             </Link>
  //           ) : (
  //             <Typography
  //               onClick={() =>
  //                 openModal(<UpgradePlanModal variant={item.title} />)
  //               }
  //               key={index}
  //               variant='body2'
  //               className='cursor-pointer'
  //             >
  //               {nested.title}
  //             </Typography>
  //           )
  //         )}
  //     </div>
  //   }
  // >
  // {/* </Tooltip> */}
};

export default SideMenuItem;
